const API_BASE = process.env.REACT_APP_API_BASE;

export default {
  API_BASE,
};